// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error404_errorContainer__fBj9Y","errorInfo":"Error404_errorInfo__2VLSd","descrError":"Error404_descrError__0MJet","error404Img":"Error404_error404Img__sx0aO"};